import * as Yup from 'yup';
import moment from 'moment';
import { directions } from '../constants';

const versionRegEx = /^(?!0.0.0|[0][.][0]$)[0-9]{1,2}([.][0-9]{1,2})([.][0-9]{1,2})?$/;

function cmpVersions(a, b) {
  let diff;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = a.replace(regExStrip0, '').split('.');
  const segmentsB = b.replace(regExStrip0, '').split('.');
  const l = Math.min(segmentsA.length, segmentsB.length);

  for (let i = 0; i < l; i += 1) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segmentsA.length - segmentsB.length;
}

export default Yup.object().shape(
  {
    responsible: Yup.string()
      .nullable()
      .when('direction', {
        is: direction => direction !== directions.INCEDENT,
        then: Yup.string().required('required'),
      }),
    game: Yup.string().required('required'),
    platform: Yup.string().required('required'),
    dateTime: Yup.string()
      .typeError('Incorrect date-time format')
      .required('required'),
    serverVersion: Yup.string()
      .nullable()
      .when('eventType', {
        is: eventType => eventType === 'server_release',
        then: Yup.string().required('required'),
      }),
    appVersion: Yup.string()
      .nullable()
      .when('eventType', {
        is: eventType => eventType === 'client_release',
        then: Yup.string()
          .matches(versionRegEx, {
            message: 'Incorrect version format',
          })
          .required('required'),
      }),
    minAppVersion: Yup.string()
      .nullable()
      .matches(versionRegEx, { message: 'Incorrect version format' })
      .when('appVersion', {
        is: appVersion => !appVersion,
        then: Yup.string().matches(versionRegEx, {
          message: 'Incorrect version format',
        }),
      }),
    maxAppVersion: Yup.string()
      .nullable()
      .matches(versionRegEx, { message: 'Incorrect version format' })
      .test(
        'greater-than-min',
        'Should be greater than min version',
        function test() {
          const { minAppVersion, maxAppVersion } = this.parent;
          if (!minAppVersion || !maxAppVersion) {
            return true;
          }
          return cmpVersions(maxAppVersion, minAppVersion) > 0;
        },
      )
      .when('appVersion', {
        is: appVersion => !appVersion,
        then: Yup.string().matches(versionRegEx, {
          message: 'Incorrect version format',
        }),
      }),
    notesLink: Yup.string()
      .nullable()
      .when('direction', {
        is: direction => direction !== directions.CRM,
        then: Yup.string()
          .url()
          .required('required'),
      }),
    engineVersion: Yup.string()
      .nullable()
      .when('eventType', {
        is: eventType => eventType === 'engine_release',
        then: Yup.string()
          .matches(versionRegEx, {
            message: 'Incorrect version format',
          })
          .required('required'),
      }),
    description: Yup.string().required('required'),
    resolutionDate: Yup.string()
      .nullable()
      .test(
        'greater-than-start',
        'Should be greater than start date',
        function test() {
          const { dateTime, resolutionDate } = this.parent;
          if (!dateTime || !resolutionDate) {
            return true;
          }
          return moment(resolutionDate).isAfter(dateTime);
        },
      ),
  },
  [['minAppVersion', 'maxAppVersion']],
);
